import React from 'react';
import ReleaseCard from './ReleaseCard';

export default function ReleaseV1110({ createThumbnail }) {
  return (
    <ReleaseCard version="v1.11.0 - v1.11.4" date="29th August 2026"
        title="Live clock on your lock screen, smarter notifications & a fresh new look!">
      <p className="text-gray-300 mb-4">v1.11.0 brings the tournament right to your lock screen and makes it easier than ever to stay in the loop. Here's what's new:</p>
      <div className="mb-6">
        <h5 className="text-lg font-medium text-purple-400 mb-2">Live Tournament Clock on Your Lock Screen</h5>
        <p className="text-gray-300 mb-4">
          The blind clock now runs as a Live Activity right on your lock screen — always visible, always counting. Tap it to jump straight into the game.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Game Start & Finish Notifications</h5>
        <p className="text-gray-300 mb-4">
          Never miss a thing. Get a push notification the moment a game kicks off and when it wraps up, so you're always in the know — even when you're away from the app.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">RSVP from the Notification</h5>
        <p className="text-gray-300 mb-4">
          When a game is announced, just tap "Are you going?" right from the notification — no need to open the app. One tap and your host knows you're in.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">New Alert Sounds</h5>
        <p className="text-gray-300 mb-4">
          Shake things up with fresh blind-change alerts including an air horn and a break bell. Or switch to silent mode if you prefer to keep things low-key.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Floating Mini Clock</h5>
        <p className="text-gray-300 mb-4">
          A compact floating clock stays on screen while you browse the app, so you can check chip counts, update results, or manage players without losing sight of the blinds.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Landscape Clock View</h5>
        <p className="text-gray-300 mb-4">
          Turn your phone sideways for a big, bold clock that's easy to read from across the table — ideal for using your device as the table timer.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Edit Games, Venues & Admins</h5>
        <p className="text-gray-300 mb-4">
          Full control at your fingertips. Edit game and venue details on the fly, and add or remove club admins without any workarounds.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Private & Public Venues</h5>
        <p className="text-gray-300 mb-4">
          Venues can now be set to private or public. Keep your home game invite-only or open your venue up for new players to discover.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Redesigned Leaderboard Podium</h5>
        <p className="text-gray-300 mb-4">
          The leaderboard podium has been given a fresh new look — a sharper, more celebratory design that makes the top spots feel truly special.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Faster & More Reliable</h5>
        <p className="text-gray-300 mb-4">
          Speed improvements across the app plus a round of bug fixes to keep everything running like a well-shuffled deck.
        </p>
      </div>
    </ReleaseCard>
  );
}
